import { useState } from 'react';

import { TabPanel, Tabs, type TabItem } from '@/components/ui';

import { AdminConfigList } from './lists/AdminConfigList';
import { AdminLaufzeitList } from './lists/AdminLaufzeitList';

/**
 * Settings — Port von `IwmAdminKonfiguration.razor` (REQ-29 §4). Aus dem inneren Menü sind
 * Reiter geworden; die Beschriftungen und ihre Reihenfolge bleiben.
 */
type TabId = 'allgemein' | 'laufzeiten';

const TABS_ID = 'iwm-admin-config';

/** Reihenfolge wie heute: Die Anzeige sortierte das Menü über `OrderBy(e => e.Label)`. */
const TABS: TabItem[] = [
  { id: 'allgemein', label: 'Allgemein' },
  { id: 'laufzeiten', label: 'Laufzeiten' },
];

export function AdminConfiguration() {
  // `SelectedEntry` startet im Altclient auf dem Enum-Wert 0 — `Allgemein`.
  const [tab, setTab] = useState<TabId>('allgemein');

  return (
    <div className="iwm-admin-config">
      <Tabs
        id={TABS_ID}
        items={TABS}
        value={tab}
        ariaLabel="Bereiche der Konfiguration"
        stretch
        onChange={(id) => {
          setTab(id as TabId);
        }}
      />
      <TabPanel tabsId={TABS_ID} id="allgemein" active={tab === 'allgemein'}>
        {/* Wie heute wird nur der gewählte Bereich geladen. */}
        {tab === 'allgemein' ? <AdminConfigList /> : null}
      </TabPanel>
      <TabPanel tabsId={TABS_ID} id="laufzeiten" active={tab === 'laufzeiten'}>
        {tab === 'laufzeiten' ? <AdminLaufzeitList /> : null}
      </TabPanel>
    </div>
  );
}

export default AdminConfiguration;
